import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { URLS } from "../../services/urls";
import useSWR from "swr";
import { Link, useNavigate } from "react-router-dom";
import { DEFAULT_PAGE_COUNT } from "../../core/utils/consts";
import { Row } from "reactstrap";
import { formatDate } from "../../core/utils/date.utils";
//import { isAdministrator } from "../../core/utils/functions";

const Logging = () => {
  const navigate = useNavigate();
  //const isAdmin = isAdministrator();

  {/*useEffect(() => {
    if (!isAdmin) {
      navigate("/login");
    }
  }, [isAdmin, navigate]);*/}

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");

  const { data, isLoading } = useSWR(URLS.LOGGING.list(search) + '?page=' + page);  // console.log(data);
  const { t } = useTranslation();

  const handleSearch = () => {
    setSearch(inputSearch);
  };
  const handleChangePage = (event, pg) => {
    event.preventDefault();
    setPage(pg);
  };

  return (
    <div>
      <div className="box-content">
        <div className="box-title">
          <h3 className="mb-35 fw-bold">{t("Logs")}</h3>
        </div>

        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <div className="panel-white mb-30">
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div>
                        <div className="d-flex">
                          <div className="form-group mx-sm-3 mb-0">
                            <input
                              value={inputSearch}
                              onChange={(e) => setInputSearch(e.target.value)}
                              type="text"
                              className="form-control"
                              id="inputPassword2"
                              placeholder={t("textSearch")}
                            />
                          </div>
                          <button
                            onClick={handleSearch}
                            type="submit"
                            className="btn btn-default "
                          >
                            {t("textSearch")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="panel-white mb-30">
                <div className="box-padding">
                  {isLoading && (
                    <div className="d-flex">
                      <div className="col-12 mb-10 d-flex">
                        <span
                          className="spinner-border m-auto"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </div>
                    </div>
                  )}
                  {!isLoading && data && (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">{t("Ip")}</th>
                            <th scope="col">{t("Agent")}</th>
                            <th scope="col">{t("Created_at")}</th>
                            <th scope="col">{t("email")}</th>
                            <th scope="col">{t("Country")}</th>
                            <th scope="col">{t("City")}</th>
                            <th scope="col">{t("Path")}</th>
                            <th scope="col">{t("Method")}</th>
                            <th scope="col">{t("Scheme")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.results?.map((config) => (
                            <tr className="hover">
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.ip}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.agent}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {formatDate(config?.created_at)}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.user?.email}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.country.name}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.city?.name}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.path}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.method}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {config?.scheme}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
              <div className="panel-white mb-30">
                <div className="p-3">
                  <div className="paginations">
                    <ul className="pager">
                      <li>
                        <Link
                          tabIndex={-1}
                          onClick={(event) => handleChangePage(event, page - 1)}
                          className={`pager-prev ${
                            page === 1 ? "disabled" : ""
                          }`}
                          to="#"
                        ></Link>
                      </li>
                      {data &&
                        new Array(Math.ceil(data.count / DEFAULT_PAGE_COUNT))
                          .fill(3)
                          .map((pag, index) => (
                            <li
                              key={"page" + index}
                              className={` ${
                                page === index + 1 ? "active" : ""
                              }`}
                              aria-current="page"
                            >
                              <Link
                                className={`pager-number ${
                                  page * DEFAULT_PAGE_COUNT ===
                                  Math.ceil(data.count)
                                    ? "disabled"
                                    : ""
                                } ${page === index + 1 ? "active" : ""}`}
                                to="#"
                                tabIndex={-1}
                                onClick={(event) =>
                                  handleChangePage(event, index + 1)
                                }
                              >
                                {index + 1}
                              </Link>
                            </li>
                          ))}
                      <li>
                        <Link
                          tabIndex={-1}
                          className={`pager-next ${
                            page === 1 ? "disabled" : ""
                          }`}
                          to="#"
                        ></Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logging;
